"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORK = exports.AMM_DEVNET_NODES = exports.DEVNET_NODES = exports.TESTNET_NODES = exports.MAINNET_NODES = exports.MAINNET_CLIO_NODES = exports.Network = void 0;
var Network;
(function (Network) {
    Network["MAINNET"] = "Mainnet";
    Network["TESTNET"] = "Testnet";
    Network["DEVNET"] = "Devnet";
    Network["AMM_DEVNET"] = "AMM-Devnet";
    Network["CUSTOM"] = "Custom";
})(Network = exports.Network || (exports.Network = {}));
exports.MAINNET_CLIO_NODES = ['wss://s1.ripple.com', 'wss://s2.ripple.com'];
exports.MAINNET_NODES = __spreadArray(['wss://xrplcluster.com'], exports.MAINNET_CLIO_NODES, true);
exports.TESTNET_NODES = ['wss://s.altnet.rippletest.net:51233', 'wss://testnet.xrpl-labs.com'];
exports.DEVNET_NODES = ['wss://s.devnet.rippletest.net:51233'];
exports.AMM_DEVNET_NODES = ['wss://amm.devnet.rippletest.net:51233'];
exports.NETWORK = (_a = {},
    _a[Network.MAINNET] = {
        name: Network.MAINNET,
        server: exports.MAINNET_NODES[0],
        nodes: exports.MAINNET_NODES,
        description: 'Main network using the production version of the XRP Ledger.'
    },
    _a[Network.TESTNET] = {
        name: Network.TESTNET,
        server: exports.TESTNET_NODES[0],
        nodes: exports.TESTNET_NODES,
        description: 'Acts as a testing network, without impacting production users and risking real money.'
    },
    _a[Network.DEVNET] = {
        name: Network.DEVNET,
        server: exports.DEVNET_NODES[0],
        nodes: exports.DEVNET_NODES,
        description: 'A preview of upcoming features, where unstable changes are tested out.'
    },
    _a[Network.AMM_DEVNET] = {
        name: Network.AMM_DEVNET,
        server: exports.AMM_DEVNET_NODES[0],
        nodes: exports.AMM_DEVNET_NODES,
        description: 'XLS-30d Automated Market Makers preview network.'
    },
    _a[Network.CUSTOM] = {
        name: Network.CUSTOM,
        server: '',
        description: 'Custom network'
    },
    _a);
